import React from 'react';
import TypewriterAuto from '../../gral-components/TypewriterAuto';
import '../stylesheets/blog-header.scss';
import { IconBxChevronLeft, IconBxChevronRight } from '../../icons/icons';
import BlogerMini from './BlogerMini';



class BlogHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      postToShow: this.props.images,
      indexHover: 2,
      arrowVisibility: {
        opacity: '0'
      }
    };
  }
  handleMouseLeave = () => {
    this.setState({
      arrowVisibility: {
        opacity: '0'
      }
    })
  }
  handleMouseEnter = () => {
    this.setState({
      arrowVisibility: {
        opacity: '1'
      }
    })
  };
  handleClickRight = () => {
    let postToShow = this.state.postToShow;
    let cuttingEnd = postToShow.slice(-1);
    let cuttingRest = postToShow.slice(0, postToShow.length - 1)
    this.setState({
      postToShow: cuttingEnd.concat(cuttingRest)
    });
  };
  handleClickLeft = () => {
    let postToShow = this.state.postToShow;
    let cuttingStart = postToShow.slice(0, 1);
    let cuttingRest = postToShow.slice(1);
    this.setState({
      postToShow: cuttingRest.concat(cuttingStart)
    })
  };
  render() {
    let postToShow = this.state.postToShow;
    let fivePost = postToShow.slice(0, 5);
    let indexHover = this.state.indexHover;
    let dataBloger = this.props.images;

    return (
      <div className='header-blog-container'>
        <div className='header-blog-left-container'>
          {
            fivePost
              .filter((element, index) => indexHover === index)
              .map((element, index) =>
                <div
                  key={index}
                  className='main-post-container'
                  onMouseEnter={this.handleMouseEnter}
                  onMouseLeave={this.handleMouseLeave}
                >
                  <div
                    className='post-arrow-left'
                    style={this.state.arrowVisibility}
                    onClick={this.handleClickLeft}
                  >
                    <i><IconBxChevronLeft /></i>
                  </div>
                  <div className='main-post-image-container'>
                    <img
                      className='main-post-image'
                      src={element.image}
                      alt={element.alt}
                    />
                  </div>
                  <div className='main-post-description'>
                    <h4 className='post-author'>
                      {element.name}
                    </h4>
                    <h2 className='post-title'>
                      {element.title}
                    </h2>
                    <h4 className='bloger-item-text'>
                      {element.description}
                    </h4>
                  </div>
                  <div
                    className='post-arrow-right'
                    style={this.state.arrowVisibility}
                    onClick={this.handleClickRight}
                  >
                    <i><IconBxChevronRight /></i>
                  </div>
                </div>
              )
          }
        </div>
        <div className='header-blog-right-container'>
          <div className='username-container'>
            <h2>{`Hello `}</h2>
            <h3>{this.props.firstname}</h3>
          </div>
          <div className='typewriter-container'>
            <TypewriterAuto
              textWriter={this.props.textWriter}
            />
          </div>
          <div className='subscribe-blog-container'>
            <h2>Blog subscribe </h2>
            <div className='subscribe-input-container'>
              <form className='form-subscribe-bar'>
                <input
                  className='form-subscribe-input'
                  type='subscribe'
                  placeholder='Ingress your email...'
                />
                <button className='form-buttom'>
                  <h3>Subscribe</h3>
                </button>
              </form>

            </div>
          </div>
          <div className='more-popular-post-container'>
            <h2>Most popular post</h2>
            <div className='bloger-mini-container'>
              <BlogerMini
                src={dataBloger[0].image}
                alt={dataBloger[0].alt}
                author={dataBloger[0].name}
                title={dataBloger[0].title}
              />
              <BlogerMini
                src={dataBloger[1].image}
                alt={dataBloger[1].alt}
                author={dataBloger[1].name}
                title={dataBloger[1].title}
              />
              <BlogerMini
                src={dataBloger[2].image}
                alt={dataBloger[2].alt}
                author={dataBloger[2].name}
                title={dataBloger[2].title}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BlogHeader;